<template>
  <i
    :class="['material-icons', { 'icon-button': type === 'button' }]"
    :style="{
      fontSize: size ? `${size}px` : '24px',
    }"
    @click.stop="$emit('click', $event)"
  >
    <slot />
  </i>
</template>

<script>
export default {
  props: ["size", "type"],
};
</script>

<style lang="scss"></style>
